import React from "react";
import AdminCustomers from "./AdminCustomers";
export default function AdminLoyalty() { return <AdminCustomers loyalty />; }
